import { render } from "./Configurazioni.vue?vue&type=template&id=6d51f89a&ts=true"
import script from "./Configurazioni.vue?vue&type=script&lang=ts"
export * from "./Configurazioni.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__